/**
 * 训练分类树业务对象，负责管理训练的分类
 */

import tree from '../base';

/**
 * 工具函数：从分类记录队列构建分类树
 */
let tree_constructor = (nodes)=>
{
  let orphans = {};
  let structed = {};
  for (let node of nodes)
  {
    let data = node.data;
    let pid = data.pid;
    let id = data.id;
    structed[id] = node;
    if (undefined !== orphans[id])
    {
      orphans[id].forEach(x=>node.insertChild(x));
      delete orphans[id];
    }
    if (undefined !== structed[pid])
    {
      structed[pid].insertChild(node);
      continue;
    }
    if (undefined === orphans[pid])
    {
      orphans[pid] = [];
    }
    orphans[pid].push(node);
  }
  return Object.values(orphans).reduce((x, y)=>x.concat(y), []);
}

class TrainCategory
{
  constructor(treeNode, categories)
  {
    this._node = treeNode; //构建好的tree结构
    this._catTree = categories; //TrainCategories类 包含_categories和_leafs
  }
  get parentCategory()
  {
    return new TrainCategory(this._node.parent, this._catTree);
  }
  get subCategories()
  {
    if (this._catTree._leafs[this._node.data.id] === this._node)
    {
      return [];
    }
    return this._node.children.map(x=>new TrainCategory(x, this._catTree));
  }
  get title()
  {
    return this._node.data.label || this._node.data.name;
  }
  get leafs()
  {
    if (this._catTree._leafs[this._node.data.id] === this._node)
    {
      return [this];
    }
    return this.subCategories.reduce((x, y)=>x.concat(y.leafs), []);
  }
  get games()
  {
    return this.leafs.reduce((x, y)=>x.concat(y._node.children.map(z=>z.data)), []);
  }
  get children()
  {
    //TODO implement me
  }
};

class TrainCategories
{
  constructor(category_entries)
  {
    //将每个脑能力转化成treeNode
    category_entries = category_entries.map(x=> new tree.TreeNode(x));
    //构建tree父子关系结构
    this._categories = tree_constructor(category_entries);
    //leafs是所有一级脑能力的数组
    let leafs = category_entries.filter(x=>x.children.length === 0);
    let leaf_map = {}
    //构建一个键为一级脑能力id,值为脑能力对象的map对象
    leafs.forEach(x=>leaf_map[x.data.id] = x);
    this._leafs = leaf_map;
  }
  get rootCategory()
  {
     return new TrainCategory(this._categories[0], this);
  }
  resetGames(games,isEval)
  {
    //将游戏与一级脑能力进行关联
    games = games.map(x=>new tree.TreeNode(x));
    Object.values(this._leafs).forEach(x=>x.clearChildren());
    if(isEval){
      games.forEach(x=>
        {
          try
          {
            if(x.data.scaleTagId){
              this._leafs[x.data.scaleTagId].insertChild(x);
            }
          }
            catch(ex)
          {
            console.log(ex);
          }
      });
      console.log(this);
    }else{
      games.forEach(x=>
        {
          x.data.label.split(',').forEach(y=>
          {
            try
          {
            this._leafs[y].insertChild(x);
          }
            catch(ex)
          {
            console.log(ex);
          }
        });
      });
    }
  }
}

export default {
  TrainCategories,
}



// WEBPACK FOOTER //
// ./src/components/common/tree/train-categories/index.js